module.exports = __webpack_public_path__ + "assets/img/img-future-01.5c76d08e.jpg";